export default "__VITE_ASSET__b1YntIFB__"